<template>
	<li class="Footer-listItem">
		<a :href="prefix + href" class="Footer-link">
			<slot></slot>
		</a>
	</li>
</template>

<script>
export default {
	name: 'CloFooterListItem',
	components: {},
	props: {
		href: {
			type: String,
			required: true,
		},
		prefix: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss">
.Footer-listItem {
	@include stack-xs;
}
.Footer-link {
	color: $color-white;
}
</style>
